import React, { PureComponent } from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input
} from 'reactstrap'

class BuildNetlify extends PureComponent {
    
    constructor(props) {
        super(props);
    
        this.state = {
            confirmText: 'Build',
            cancelText: 'Cancel',
            prompt: 'Are you sure you want to rebuild this site?',
          };
    }

  render() {
    return (
      <Modal
        isOpen={this.props.open}
        toggle={this.toggle}
        className={this.props.className}
      >
        <ModalHeader toggle={this.props.close}>Build Site?</ModalHeader>
        <ModalBody>{this.state.prompt}</ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={this.props.onClose}
            disabled={this.props.buttonsDisabled}
          >
            {this.state.cancelText}
          </Button>
          <Button
            color="primary"
            onClick={this.props.onBuildNetlify}
            disabled={this.props.buttonsDisabled}
          >
            {this.state.confirmText}
          </Button>
        </ModalFooter>
      </Modal>
    )
  }
}
export default BuildNetlify;


// WEBPACK FOOTER //
// ./src/views/Components/BuildNetlify.js